import styled from 'styled-components';

const CircleArrowContainer = styled.div`
    display: block;
    height: ${(props) => props.circleDiameter + 'px'}; 
    margin: auto;    
    width: ${(props) => props.circleDiameter + 'px'};
`;

export default CircleArrowContainer;


// WEBPACK FOOTER //
// ./src/images/animations/CircleArrow/CircleArrowStyles.js